import { defineComponent as _defineComponent } from 'vue'
import UnitCard from '@/components/units/UnitCard'

export default /*#__PURE__*/_defineComponent({
  __name: 'UnitGroup',
  props: {
    unitNumberId: null,
    unitSideSheetUrl: { default: 'sv-unit-overview' }
  },
  setup(__props: any) {



return { __sfc: true,UnitCard }
}

})